<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>보고서 의뢰 등록정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">등록자</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_name}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">등록일</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.reg_date}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">이메일</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_email}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">휴대폰번호</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_phone}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">회사 정보</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_company}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">직책 정보</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_position}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">제목</label>
                  </td>
                  <td class="" colspan="3" style="vertical-align:middle">{{reqDatas.title}}</td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">내용</label>
                  </td>
                  <td class="" colspan="3" style="vertical-align:middle"><div v-html="reqDatas.contents"></div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>
              <div>보고서 의뢰 답변</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{reqDatas.reply_reg_user}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변상태</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{reqDatas.qastatus_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{reqDatas.reply_title}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" style="vertical-align:middle"><div v-html="reqDatas.reply_contents"></div></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <!-- <b-button variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px" 
                            v-on:click="drQaDelete(noticecode)"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button> -->
                </b-col>
                <b-col md="4">
                  <b-button variant="warning" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px" 
                            v-if="reqDatas.qastatus == '1'" v-bind:href="'#/customer/reportrequest/form'"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" 
                            v-bind:href="'#/customer/reportrequestpublic'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      reqCode: '',
      reqDatas: {},
      queryParams: {
        id:''
      },
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.reqCode = self.$session.get('reqCode');

    if(self.reqCode != undefined){
      self.getRequestData();
    }
  },
  methods: {
    // 문의 정보 조회
    getRequestData() {
      var self = this;
      self.queryParams.id = self.reqCode;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/reportRequestData?access_token=' + token, data, null)
        .then((result) => {
          // console.log(result.data);
          self.reqDatas = result.data;
      });
    },
    drQaDelete(){
      var self = this;

      swal.fire({
        title: '답변 삭제!',
        html: "현재 고객문의의 저장된 답변</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          var urlPath = '';
          self.queryParams.qastatus = 1;
          self.queryParams.reply_id = self.reqDatas.reply_id;

          // console.log(self.queryParams);
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          self.$http.post('/api/delete/qaReply?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '답변이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/customer/qamanager";
              });
          })
        }else{
          // cansel
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customer/ReportRequestInfo.vue